import React from 'react'
import { Stack } from '@mui/material'
import UIModal from '../../../ui/UIModal/UIModal'
import UITextHeadlineLarge from '../../../ui/UIText/UITextHeadlineLarge'
import UIButtonMediumDanger from '../../../ui/UIButton/UIButtomMediumDanger'
import UIButtonMediumHollow from '../../../ui/UIButton/UIButtonMediumHollow'
import UITextTitleMedium from '../../../ui/UIText/UITextTitleMedium'

const DeleteApiKeyModal = ({ data, open, setOpen, handleSubmit, isLoading }) => {
  return (
    <UIModal wrapperStyles={{ width: '600px' }} open={open} setOpen={setOpen}>
      <Stack gap="30px">
        <UITextHeadlineLarge sx={{ fontSize: '28px', lineHeight: 'normal' }}>
          Are you sure you want to delete API key <br /> &quot;
          <span style={{ fontWeight: 700 }}>{data?.label}</span>&quot;?
        </UITextHeadlineLarge>
        <Stack direction="row" gap="10px">
          <UIButtonMediumHollow fullWidth onClick={() => setOpen(false)}>
            Cancel
          </UIButtonMediumHollow>
          <UIButtonMediumDanger disabled={isLoading} fullWidth onClick={() => handleSubmit()}>
            Delete
          </UIButtonMediumDanger>
        </Stack>
      </Stack>
    </UIModal>
  )
}

export default DeleteApiKeyModal
